import { autoinject, computedFrom, transient } from "aurelia-framework";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { VetClientModel, VetRuleOutcomeStepEnum, VetTaskClientModel } from "../../../../../../../models/vetting/vetting.models";
import { RightShipDialogServiceConstants } from "../../../../../../../constants/basics/rightship-dialog.constants";
import { VettingService } from "../../../../../../../services/vetting/vetting.service";
import { Claims } from "../../../../../../../constants/authentication/claims";
import { UserClaimsService } from "../../../../../../../services/authentication/user-claims.service";
import * as Enumerable from "linq";

@autoinject()
@transient()
export class TradeCheckCTARulesDialog {

    public selectedOutcomes: number[] = [];
    public item: VetClientModel;
    public selectedVetTaskKey: string;
    public canViewRiskScoresInScreeningOverview: boolean;
    public detailsExpanded: { [vetTaskId: number]: boolean } = {};

    constructor(private dialogClientService: DialogClientService, private userClaimsService: UserClaimsService, private vetClient: VettingService) { 
        this.selectedOutcomes.push(VetRuleOutcomeStepEnum.Fail);
        this.canViewRiskScoresInScreeningOverview = this.userClaimsService.hasPermission(Claims.CanViewRiskScoresInScreeningOverview);
    }

    async activate(param: { vet: VetClientModel; selectedVetTaskKey: string }) {
        this.item = param.vet;
        this.selectedVetTaskKey = param.selectedVetTaskKey;
    }

    get vetTasks() {
        const tasks = {};
        if (this.item) {
            const filter = this.selectedOutcomes.length > 0;
            let vetTasks = this.item.vetTasks;
            const outcomeIds = this.selectedOutcomes
            if (filter) {
                const pending = outcomeIds.filter(x => x == -1).length > 0;
                const failed = outcomeIds.filter(x => x != VetRuleOutcomeStepEnum.Pass).length > 0;
                vetTasks = vetTasks.filter(task => (pending && (!task.vetTaskOutcomeId || task.vetTaskOutcomeId <= 0)) || (failed && task.systemError) || (failed && task.vetTaskOutcomeId == VetRuleOutcomeStepEnum.NA) || outcomeIds.indexOf(task.vetTaskOutcomeId) > -1)
            }
            const items = Enumerable.from(vetTasks).groupBy(x => x.isCritical ? "Critical rules" : "Soft rules")
                .toArray();
            for (const item of items) {
                tasks[item.key()] = item.where(x => !x.isVisibleToRsVetSupersOnly && !x.isInfoOnlyRule).toArray();
            }
        }
        return tasks;
    }
    
    get vetTaskKeys() {
        if (this.item)
            return Enumerable.from(this.item.vetTasks).where(x => !x.isVisibleToRsVetSupersOnly && !x.isInfoOnlyRule)
                .orderBy(x => x.categoryIsCustomer ? 1 : 2).select(x => x.isCritical ? "Critical rules" : "Soft rules").distinct().toArray();
        return [];
    }

    @computedFrom('this.item', 'this.item.vetTasks')
    get outcomes(): { id: number; name: string }[] {
        const list = [];
        if (this.item && this.item.vetTasks) {
            const vetTasks: VetTaskClientModel[] = this.item.vetTasks;
            const passed = vetTasks.filter(task => task.vetTaskOutcomeId == VetRuleOutcomeStepEnum.Pass).length;
            const failed = vetTasks.filter(task => task.vetTaskOutcomeId != VetRuleOutcomeStepEnum.Pass || task.systemError).length;

            list.push({ id: VetRuleOutcomeStepEnum.Pass, name: `Passed (${passed})` });
            list.push({ id: VetRuleOutcomeStepEnum.Fail, name: `Failed (${failed})` });
        }

        return list;
    }

    close() {
        this.dialogClientService.hide();
    }

    toggle(element: HTMLElement, arrow: HTMLElement) {
        $(element).slideToggle()
        if ($(arrow).hasClass('is-opened')) {
            $(arrow).removeClass('is-opened');
        } else {
            $(arrow).addClass('is-opened');
        }
    }

    filterClick(outcome: { id: number; name: string }) {
        const index = this.selectedOutcomes.indexOf(outcome.id);
        if (index >= 0) {
            this.selectedOutcomes.splice(index, 1);
        }
        else {
            this.selectedOutcomes.push(outcome.id);
        }
    }

    getOutcome(x: VetTaskClientModel) {
        return x.vetSuperVetTaskOutcomeId ? x.vetSuperVetTaskOutcomeId : x.vetTaskOutcomeId;
    }

    async openAdditionalInformationDialog(task: VetTaskClientModel) {
        if (task.hasListItems && !task.hasRsListItems) {
            const listItems = await this.vetClient.getListItems(task.vetTaskId);
            this.dialogClientService.show(RightShipDialogServiceConstants.URLs.AdditionalInformationDialog, {
                listItems: listItems,
                task: task,
                vet: this.item
            }, true, false, false, "right");
        }
        else if (task.hasCap) {
            const cap = await this.vetClient.getCapResponse(this.item.vetId, task.vetTaskId);
            this.dialogClientService.show(RightShipDialogServiceConstants.URLs.AdditionalInformationDialog, {
                cap: cap,
                task: task,
                vet: this.item
            }, true, false, false, "right");
        }
        else if (task.canViewDisplayResultsInOverview) {
            this.dialogClientService.show(RightShipDialogServiceConstants.URLs.AdditionalInformationDialog, {
                task: task,
                vet: this.item
            }, true, false, false, "right");
        }
    }

    clearAllFilters(){
        this.selectedOutcomes = [];
    }

    expandDetails(vetTaskId: number) {
        if (!this.detailsExpanded) this.detailsExpanded = {};
        this.detailsExpanded[vetTaskId] = Object.keys(this.detailsExpanded).indexOf(vetTaskId.toString()) > -1 ? !this.detailsExpanded[vetTaskId] : true;
    }
}